export const getMorningtonPeninsulaData = () => ({
  name: "Mornington Peninsula",
  country: "Australie",
  description: "La Mornington Peninsula est une région viticole de climat frais du Victoria, réputée pour ses Pinot Noir élégants et ses Chardonnay complexes. Son climat maritime et ses influences océaniques créent des conditions idéales pour des vins de grande finesse.",
  type: "region",
  mapAreas: [
    { region: "Mornington Peninsula", x: 62, y: 68, color: "#f8f0f8", size: 3 }
  ],
  statistics: {
    totalArea: "3,500 ha",
    production: "0.2 million hectolitres",
    appellations: "Mornington Peninsula GI",
    subregions: "3 sous-régions principales",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat maritime avec influence océanique, étés chauds, hivers froids, précipitations régulières",
    soil: "Sols volcaniques, argileux, sableux, excellente diversité géologique",
    viticulture: "Viticulture moderne, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégants et complexes, Shiraz frais, assemblages délicats",
    white: "Chardonnay élégants et complexes, Sauvignon Blanc aromatiques, Pinot Gris frais",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle, spécialité régionale"
  },
  history: "La viticulture sur la Mornington Peninsula a débuté dans les années 1970. La région s'est rapidement imposée comme l'une des plus prestigieuses d'Australie pour les vins de climat frais, reconnue pour ses Pinot Noir et Chardonnay.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  subregions: {
    "red-hill": {
      name: "Red Hill",
      description: "Zone d'altitude, réputée pour ses Pinot Noir élégants et ses Chardonnay complexes.",
      characteristics: {
        climate: "Frais, altitude élevée",
        soil: "Sols volcaniques et argileux",
        viticulture: "Vignobles modernes, altitude élevée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Pinot Gris"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "pinot-noir": "Rouges élégants et complexes",
        "chardonnay": "Blancs frais et aromatiques"
      },
      foodPairing: "Poissons, volailles, fromages affinés"
    },
    "main-ridge": {
      name: "Main Ridge",
      description: "Zone historique, connue pour ses vins blancs frais et ses rouges élégants.",
      characteristics: {
        climate: "Maritime, influence océanique",
        soil: "Sols argileux et sableux",
        viticulture: "Vignobles historiques, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Pinot Gris"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "blanc": "Blancs frais et aromatiques",
        "rouge": "Rouges élégants et équilibrés"
      },
      foodPairing: "Fruits de mer, poissons, cuisine traditionnelle"
    },
    "moorooduc": {
      name: "Moorooduc",
      description: "Zone méridionale, réputée pour ses vins rouges structurés et ses blancs complexes.",
      characteristics: {
        climate: "Maritime, influence océanique",
        soil: "Sols argileux et calcaires",
        viticulture: "Vignobles modernes, qualité privilégiée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sauvignon Blanc", "Pinot Gris"],
        red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et complexes",
        "blanc": "Blancs complexes et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    }
  }
}); 